<template>
  <v-card 
    class="mx-auto"
  >
  <div v-if="!loading">
    <v-card-title>
      <b>{{ event.sensorIndex == 3 ? 'Χαμηλή Μπαταρία' : (event.sensorIndex == 4 ? 'Check' : (event.sensorIndex == 5 ? 'Συναγερμός' : `Φωτιά`))}} &nbsp;</b> στην περιοχή "{{ event.camp }}" -> "{{ event.sensorDescription }}", στις {{ mktime(event.timestamp) }}
    </v-card-title>
    <v-card-text class="text-left">
      Τοποθεσία (Πλάτος, Μήκος) / (Lat, Lng): {{ sensor.latitude }}, {{ sensor.longitude }} <br />

      <div v-if="event.sensorIndex < 3 || event.sensorIndex > 4">
      Κατεύθυνση Κατά Προσέγγιση : {{ sensor.orientations[event.sensorIndex != 5 ? event.sensorIndex : 0] }} &deg;<br />
      </div>

      <br />
      <div v-if="this.$store.state.user.isAdmin">
        <h2>Επικυρώσεις:</h2> <br />
        <p v-for="(item) in confirmations" :key="item.id">
          Στις {{ mktime(item.timestamp) }} από τον χρήστη "{{ item.user.userName }}", περιοχής "{{ item.user.camps.join() }}"
        </p>
        <p v-if="confirmations.length == 0">
          Καμία
        </p>
      </div>
    </v-card-text>

    <v-spacer></v-spacer>

  </div>
  <v-progress-circular v-else indeterminate></v-progress-circular>

    <p class="font-weight-regular" style="color: red;">
      {{ error }}
    </p>

  </v-card>
</template>

<script>
// import Vue from 'vue';

export default {
  name: 'EventDetails',
  props: {
    eventId: {
      type: String,
      default: undefined,
      required: true
    }
  },
  data: () => {
      return {
          loading: true,
          event: {},
          sensor: {},
          confirmations: [],
          error: ""
      }
  },
  async mounted() {
    await this.load()
  },
  watch: {
    async eventId() {
      await this.load()
    }
  },
  methods: {
    mktime(ts) {
      var dt = new Date(ts)
      dt.setTime(dt.getTime() - (new Date().getTimezoneOffset() * 60 * 1000))
      return dt.toLocaleString('el-GR')
    },
    async load(){
        if (this.eventId == undefined) {
          return
        }

        const u = this.$store.state.user

        if (!(u.camps && u.camps.length > 0)) {
          return
        }

        if (!(u.isAdmin || u.isCampMaster)) {
          this.campFilter = u.camps[0]
        }

        this.loading = true
        const query = {
            eventId: this.eventId,
            camp: this.campFilter
        }

        console.log('requesting from axios')
        try {
            var response = await this.$axios.get(`/sensorEvents`, { params: {...query} })
            if (response.data && Object.keys(response.data).length === 0 && Object.getPrototypeOf(response.data) === Object.prototype) {
              return // no events
            }

            this.event = response.data[0]
            console.log(this.event)

            response = await this.$axios.get('/sensors', { params: { id: this.event.sensorId } })
            this.sensor = response.data
            console.log(this.sensor)

            if (this.$store.state.user.isAdmin){
              response = await this.$axios.get(`/eventConfirmations/${this.event.id}`)
              this.confirmations = response.data
              console.log(this.confirmations)
            }


            this.error = ""
        } catch (e) {
            console.log(e.response.data)
            this.error = e.response.data
        }
        this.loading = false
      }
    }
}
</script>
